
import React, { Fragment } from 'react';
import { ArcaHttpClientPerson } from '../../../code/ArcaHttpClientPerson';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaLogoHeader } from '../ReactIcons/ArcaLogoHeader';

export class CustomerStatusPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            person: this.props.person,
            statusText: null,
            isError: false
        };
    }

    refresh(person) {
        this.setState({ person })
    }

    onPark() {
        this.setStatus('Parked')
    }

    setStatus(status) {
        let { person } = this.state;

        person.State = status

        ArcaHttpClientPerson.UpdateAsync(
            person,
            (this.refresh.bind(this, person)),
            (msg => this.setState({ isError: true, statusText: msg }))
        )
    }

    render() {
        let { person, statusText, isError } = this.state;

        let text = ''
        let buttonText = ''
        let promotedStatus = ''
        const width = ArcaHttpSystem.IsSmartphone ? '100%' : '45%'

        switch (person.State) {
            case 'Prospect':
                text = 'This prospect can be onboarded. Please promote if you are prepared to commit to onboarding.'
                buttonText = 'Begin on-boarding'
                promotedStatus = 'On-boarding'
                break;

            case 'On-boarding':
                text = 'This customer is undergoing the process of onboarding. Please promote to commit to a full customer when you are satisfied that the account is ready.'
                buttonText = 'Make full customer'
                promotedStatus = 'Registered'
                break;

            case 'Parked':
                text = 'The account is parked. Unpark to set back to a prospect.'
                buttonText = 'Unpark'
                promotedStatus = 'Prospect'
                break;

            case 'Registered':
                text = 'The customer has undergone the on-boarding process and can now book walks for pets.'
                buttonText = 'Unpark'
                promotedStatus = 'Prospect'
                break;
        }

        return (
            <Fragment>
                {ArcaSecurity.IsAdmin && person.Type === 'Owner'
                    ? <Fragment>
                        <div className="rounded px-3 px-sm-4 py-3 py-sm-5">

                            {person.State === 'Registered'
                                ? <h1>{person.State}</h1>
                                : <h1>{person.State} - {person.CreatedDate.DateAndTimeShortPretty}</h1>}
                            <p>{text}</p>

                            {ArcaHttpSystem.IsSmartphone ? <br /> : null}
                            {person.EnquireNotes && person.State !== 'Registered'
                                ? <Fragment>
                                    <h1>Enquiry Details</h1>
                                    {ArcaHttpSystem.Log(person.EnqireNotes)}
                                    {person.EnquireNotes}
                                </Fragment>
                                : null}
                            <br/>
                            <br />

                            {person.State !== 'Registered'
                                ? <ArcaLink disable={false} text={buttonText} onClick={() => this.setStatus(promotedStatus)} width={width} />
                                : null}
                            {ArcaHttpSystem.IsSmartphone ? <br /> : null}

                            {person.State !== 'Parked' && person.State !== 'Registered'
                                ? <ArcaLink disable={false} text='Park the customer' onClick={() => this.onPark()} width={width} />
                                : null}


                            <StatusBar message={statusText} isError={isError} />
                        </div>
                    </Fragment>
                    : null}
            </Fragment>
        );
    }
}
